import type { PieceType, Team } from '@halvard/rules';

const BODY: Readonly<Record<Team, string>> = { I: '#EFE8D8', B: '#30343B' };
const RING: Readonly<Record<Team, string>> = { I: '#E8742E', B: '#4FB3C4' };

/** Flat silhouette of a piece, matching the 3D models: body colour plus the team ring. */
export function PieceGlyph({
  team,
  type,
  size = 24,
}: {
  team: Team;
  type: PieceType;
  size?: number;
}) {
  const body = BODY[team];
  const ring = RING[team];
  const stroke = { stroke: ring, strokeWidth: 1.2, strokeLinejoin: 'round' as const };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <ellipse cx="12" cy="21" rx="8" ry="2" fill="none" stroke={ring} strokeWidth="1.8" />
      {type === 'B' && (
        <g fill={body} {...stroke}>
          <rect x="7" y="17" width="10" height="3" rx="1" />
          <rect x="10.5" y="9" width="3" height="8" />
          <path d="M12 2 L15.5 6 L12 10 L8.5 6 Z" fill={ring} />
        </g>
      )}
      {type === 'C' && (
        <g fill={body} {...stroke}>
          <path d="M8.5 20 L7 13 L9 8 L13 8 L15 13 L13.5 20 Z" />
          <circle cx="11" cy="5.5" r="2.5" />
          <path d="M17 19 L19 7 M16 7.5 L21 6.5" fill="none" stroke={ring} strokeWidth="1.6" />
        </g>
      )}
      {type === 'X' && (
        <g fill={body} {...stroke}>
          <ellipse cx="12" cy="13" rx="6" ry="3.5" />
          <path
            d="M8 16 L8 20 M11 16 L11 20 M14 16 L14 20 M16.5 15 L16.5 20"
            stroke={body === '#30343B' ? ring : body}
            strokeWidth="1.6"
          />
          <rect x="15" y="7" width="4" height="4" rx="1" />
          <path
            d="M16 7 C 14 3, 18 2, 17 5 M18.5 7 C 18 3, 22 3, 20.5 6"
            fill="none"
            stroke={ring}
            strokeWidth="1.5"
          />
        </g>
      )}
      {type === 'L' && (
        <g fill={body} {...stroke}>
          <path d="M9 20 L10 8 L14 8 L15 20 Z" />
          <rect x="8" y="7" width="8" height="1.6" fill={ring} />
          <path d="M8 7 L12 2 L16 7 Z" />
        </g>
      )}
      {type === 'M' && (
        <g fill={body} {...stroke}>
          <rect x="5.5" y="15" width="13" height="5" rx="0.5" />
          <rect
            x="7.5"
            y="10"
            width="9"
            height="5"
            rx="0.5"
            fill={ring}
            transform="rotate(-6 12 12.5)"
          />
          <rect x="9.5" y="5.5" width="5" height="4.5" rx="0.5" transform="rotate(8 12 8)" />
        </g>
      )}
    </svg>
  );
}
